import { render, staticRenderFns } from "./SaisonList.vue?vue&type=template&id=1fbfafde&scoped=true&"
import script from "./SaisonList.vue?vue&type=script&lang=js&"
export * from "./SaisonList.vue?vue&type=script&lang=js&"
import style0 from "./SaisonList.vue?vue&type=style&index=0&id=1fbfafde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbfafde",
  null
  
)

export default component.exports